/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';
import Switcher from '@spotahome/ui-library/src/tenant/components/Switcher/Switcher';

import './SearchModeSwitcher.scss';

const NOOP = () => {};

/**
 * Two-state toggle between the classic search experience (right) and the
 * agentic chat (left). Shared between the agentic header and the classic
 * search filters bar so both surfaces flip with the same visual contract.
 *
 * `mode` decides which side is active (drives `isPositionRight`); only the
 * inactive side wires a click handler — the active side is a no-op.
 */
export const SearchModeSwitcher = ({
  mode,
  onSwitchToAgentic = NOOP,
  onSwitchToClassic = NOOP,
  className = ''
}) => (
  <Switcher
    isPositionRight={mode === 'classic'}
    onClickLeft={mode === 'agentic' ? NOOP : onSwitchToAgentic}
    onClickRight={mode === 'classic' ? NOOP : onSwitchToClassic}
    renderLeftIcon={() => (
      <span className="sah-search-mode-switcher__option">
        <DSIcon name="auto_awesome" size="s" />
        {trans('marketplace.agentic.searchMode.assistant')}
      </span>
    )}
    renderRightIcon={() => (
      <span className="sah-search-mode-switcher__option">
        <DSIcon name="search" size="s" />
        {trans('marketplace.agentic.searchMode.classic')}
      </span>
    )}
    dataTest="search-mode-switcher"
    colorSchema="white-inverted"
    className={className}
  />
);

SearchModeSwitcher.propTypes = {
  mode: PropTypes.oneOf(['agentic', 'classic']).isRequired,
  onSwitchToAgentic: PropTypes.func,
  onSwitchToClassic: PropTypes.func,
  className: PropTypes.string
};

export default SearchModeSwitcher;
